import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appBlockcutcopypaste]'
})
export class BlockcutcopypasteDirective {
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }
  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }
  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
}
